import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Api, ApiAuth } from 'app/domain/api';
import { ApiResponse } from 'app/domain/auth.model';
import { CompanyDTO } from 'app/domain/api.model';


@Injectable({ providedIn: 'root' })
export class CompanyService {

  constructor(private http: HttpClient) { }

  private _companies = new BehaviorSubject<CompanyDTO[]>([]);

  get companies$(): Observable<CompanyDTO[]> {
    return this._companies.asObservable();
  }

  

  getAll(): Observable<CompanyDTO[]> {
      return this.http.get<CompanyDTO[]>(Api.Companies).pipe(
        map(companies => 
          // Sort logic: (a, b) comparison
          companies.sort((a, b) => {
  const snA = a?.name ?? '';
  const snB = b?.name ?? '';
  return snA.localeCompare(snB);
})
        ),
        tap((sorted) => {
          this._companies.next(sorted);
        })
      );
    }

  private _companys: BehaviorSubject<CompanyDTO[] | null> = new BehaviorSubject<CompanyDTO[] | null>(null);

  get companys$(): Observable<CompanyDTO[] | null> {
    return this._companys.asObservable();
  }

  




  private _company: BehaviorSubject<CompanyDTO | null> = new BehaviorSubject<CompanyDTO | null>(null);

  get company$(): Observable<CompanyDTO | null> {
    return this._company.asObservable();
  }

  get(code: string): Observable<CompanyDTO> {
    return this.http.get<CompanyDTO>(Api.Company + '/get/' + code).pipe(
      tap((company) => {
        this._company.next(company);
      })
    );
  }



  public delete(code: String): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(Api.Company + "/" + code);
  }


  public load(): Observable<CompanyDTO[]> {
    return this.http.get<CompanyDTO[]>(Api.Company);
  }



  public save(dto: CompanyDTO): Observable<ApiResponse> { 
    if (!dto.code)
      return this.http.post<ApiResponse>(Api.Company, dto);
    else
      return this.http.put<ApiResponse>(Api.Company, dto);
  }





  private _companyLogged: BehaviorSubject<CompanyDTO | null> = new BehaviorSubject<CompanyDTO | null>(null);

  get companyLogged$(): Observable<CompanyDTO | null> {
    return this._companyLogged.asObservable();
  }

  getLogged(): Observable<CompanyDTO> {
    return this.http.get<CompanyDTO>(Api.Company + '/current').pipe(
      tap((companyLogged) => {
        this._companyLogged.next(companyLogged);
      })
    );
  }

}
